import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import SvgTagEdit from '@components/ringil3/icons/TagEdit.tsx';
import { isNotBlank } from '@utils/utils.tsx';
import SvgInfo from '@icons/info.svg?react';
import { SecuredConfig } from '@components/security/securedDecoration';
import RingilTextArea from '@components/framework/input/RingilTextArea';
import CollapsibleNote from '@components/RingilComponents/RichTextEditor/CollapsibleNote.tsx';

interface ComponentProps {
  note?: string;
  onChangeNote?: (note: string) => void;
  label?: string;
  formated?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  dataTestId?: string;
  secured?: SecuredConfig;
}

const NoteTag: React.FC<ComponentProps> = ({ note, onChangeNote, label, readOnly, formated = false, maxLength, dataTestId, secured }) => {
  const { tr } = useTranslationLgs();
  const [internalNote, setInternalNote] = useState(note);
  const [open, setOpen] = useState(false);

  const formatValue = () => {
    if (isNotBlank(note)) return formated ? <pre>{note}</pre> : <CollapsibleNote html={note} />;
    return null;
  };

  return (
    <>
      <ButtonTag
        label={label ? label : tr(`NoteTag.title`, `Note`)}
        value={formatValue()}
        icon={<SvgInfo />}
        actionIcon={<SvgTagEdit />}
        onSave={() => {
          setOpen(false);
          onChangeNote(internalNote);
        }}
        autoClose
        alignTop
        className={'max-w-[750px]'}
        readonly={readOnly}
        dataTestId={dataTestId}
        secured={secured}
      >
        <RingilTextArea value={internalNote ? internalNote : ''} onChange={v => setInternalNote(v)} rows={6} maxLength={maxLength} className={'w-[400px]'} />
      </ButtonTag>
    </>
  );
};

export default NoteTag;
